import React from "react";
import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const RoleListComponent = loadable(
  () => import("../../components/Auth/RoleList")
);

const RoleList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Roles</span>
      </div>
      <RoleListComponent />
    </>
  )
}

export default RoleList